import { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from './Button';
import { useTranslation } from '../../i18n';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  variant?: 'default' | 'error';
  onRetry?: () => void;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'default',
  onRetry,
}: EmptyStateProps) {
  const { t } = useTranslation();
  const isError = variant === 'error';

  return (
    <div className="text-center py-12 px-6">
      {icon && (
        <div className={`flex justify-center mb-3 ${isError ? 'text-red-500' : 'text-slate-400'}`}>
          {icon}
        </div>
      )}
      {!icon && isError && (
        <div className="flex justify-center mb-3 text-red-500">
          <AlertCircle className="w-10 h-10" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-[15px] font-semibold text-slate-900 tracking-tight mb-1">{title}</h3>
      {description && (
        <p className="text-[13px] text-slate-500 max-w-md mx-auto">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
      {isError && onRetry && (
        <div className="mt-4">
          <Button variant="secondary" onClick={onRetry}>
            {t('common:actions.retry')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default EmptyState;
